/**
 * Hand a Blob to the browser as a file download via a synthetic `<a download>`
 * click.
 *
 * The seventh independent copy of this idiom in the codebase got consolidated
 * here (zip-writer.ts, useExportCsv.ts, useViewExport.ts, useSupplierExport.ts
 * all had their own). The shape below merges the most defensive behavior seen
 * across those copies: appending the anchor to the DOM before calling
 * `click()` (some browsers only reliably fire click on an attached element)
 * and delaying `revokeObjectURL` rather than calling it immediately (revoking
 * synchronously risks freeing the object URL before the browser has actually
 * started the download). `useSupplierExport`'s prior copy did neither — that
 * safety margin is preserved here, not dropped.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 10_000);
}
